import { Button } from '@/components/ui/button';
import { Table } from 'lucide-react';
import * as XLSX from 'xlsx';

const FamilyTreeDownloader = ({ members }) => {

  const handleDownload = () => {
    if (!members || members.length === 0) {
      console.warn('No members data available');
      return;
    }

    const today = new Date();
    const dateStr = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    const filename = `eService_Family_Tree-${dateStr}.xlsx`;

    downloadFamilyTreeExcel(members, filename);
  };

  return (
    <div className="flex justify-between items-center">
         {/* <h2 className="text-2xl font-bold text-gray-900">شجرة العائلة</h2> */}
    <Button onClick={handleDownload} className="hover:bg-secondary">
      <Table className="h-4 w-4 ml-2" />
      تصدير Excel
    </Button>
    </div>
  );
};

function buildFamilyPaths(data) {
    if (!Array.isArray(data)) {
        console.error('Input data is not an array:', data);
        return { paths: [], maxDepth: 0 };
    }

    const nodesById = {};
    const leafPaths = [];
    let maxDepth = 0;

    data.forEach(node => {
        nodesById[node.id] = {
            ...node,
            path: []
        };
    });

    function traverseTree(node, currentPath = []) {
        // For RTL, we'll reverse the path at the end
        const newPath = [...currentPath, node.name];
        
        if (!node.children || node.children.length === 0) {
            leafPaths.push({
                id: node.id,
                path: newPath
            });
            maxDepth = Math.max(maxDepth, newPath.length);
        }

        if (node.children && Array.isArray(node.children)) {
            node.children.forEach(childId => {
                if (nodesById[childId]) {
                    traverseTree(nodesById[childId], newPath);
                }
            });
        }
    }

    const rootNodes = data.filter(node => node.isRoot === true);
    rootNodes.forEach(rootNode => {
        traverseTree(nodesById[rootNode.id]);
    });

    // Reverse all paths for RTL
    leafPaths.forEach(item => {
        item.path = item.path.reverse();
    });

    return { paths: leafPaths, maxDepth };
}

function downloadFamilyTreeExcel(data, filename = 'family_tree.xlsx') {
    const { paths, maxDepth } = buildFamilyPaths(data);
    
    if (paths.length === 0) {
        console.warn('No paths generated');
        return;
    }

    // Create headers array (reversed for RTL)
    const headers = Array.from({ length: maxDepth }, (_, i) => i==0 ? "الاسم": i==1 ? "الأب": `الجد-${(i) - 1}`);

    // Prepare data for Excel including headers
    const excelData = [
        headers,
        ...paths.map(item => {
            const row = new Array(maxDepth).fill('');
            item.path.forEach((name, index) => {
                row[index] = name;
            });
            return row;
        })
    ];

    // Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Add worksheet-level properties
    ws['!dir'] = 'rtl';
    
    // Set column widths and properties
    ws['!cols'] = Array(maxDepth).fill({ width: 20 });

    // Set RTL properties for each cell
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellref = XLSX.utils.encode_cell({ r: R, c: C });
            if (!ws[cellref]) continue;
            
            // Create or update cell properties
            if (!ws[cellref].s) ws[cellref].s = {};
            
            // Set cell formatting for RTL
            ws[cellref].s = {
                ...ws[cellref].s,
                alignment: {
                    horizontal: 'right',
                    vertical: 'center',
                    wrapText: true,
                    readingOrder: 'rtl'
                },
                font: {
                    name: 'Arial',
                    sz: 12,
                    rtl: true
                }
            };
            
            // Add RTL mark to text content
            if (ws[cellref].v && typeof ws[cellref].v === 'string') {
                ws[cellref].v = '\u200F' + ws[cellref].v;
            }
        }
    }

    // Add explicit RTL mark to the worksheet name
    XLSX.utils.book_append_sheet(wb, ws, '\u200Fشجرة العائلة');

    // Set RTL as workbook property
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Views) wb.Workbook.Views = [];
    wb.Workbook.Views[0] = { RTL: true };

    // Generate Excel file with maximum compatibility
    const writeOpts = {
        bookType: 'xlsx',
        bookSST: false,
        type: 'binary',
        cellStyles: true,
        compression: true
    };

    XLSX.writeFile(wb, filename, writeOpts);
}

export default FamilyTreeDownloader;